import { Demodal, useModal } from "demodal";
import { useRouter } from "next/router";

import InfoActionModal from "../InfoActionModal/InfoActionModal";
import useI18n from "hooks/useI18n";

import FullBagSVG from "../../../../public/assets/images/fish-in-bag.svg";

const Confirm = Demodal.create(() => {
  const modal = useModal();
  const t = useI18n();
  const { asPath } = useRouter();
  const isCheckout = asPath.includes("checkout");

  const resolve = (value: boolean | undefined) => () => {
    modal.resolve(value);
    modal.remove();
  };

  const handleClose = () => {
    resolve(undefined)();
  };

  return (
    <InfoActionModal
      className="InfoShoppingCartModal"
      opened={modal.isOpen}
      cancelAction={resolve(false)}
      cancelText={t.moveCart.cancel}
      confirmAction={!isCheckout ? resolve(true) : undefined}
      confirmText={!isCheckout ? t.moveCart.confirm : undefined}
      title={t.moveCart.title}
      closeOnClickOutside={true}
      description={t.moveCart.message}
      onClose={handleClose}
      icon={
        <div>
          <FullBagSVG />
        </div>
      }
    />
  );
});

export const InfoShoppingCartModal = (props: any) =>
  Demodal.open(Confirm, props);
